import React, { FC, useEffect, useState } from "react";
import { valid } from "baseui/payment-card";
import { InputProps, MaskedInput, MaskedInputProps } from "baseui/input";
import { getInputOverrides, PositiveEndEnhancer } from "./Input";
import { mergeOverrides } from "baseui";

const validateExpiration = (value: string | number) => {
  return Boolean(value && !valid.expirationDate(value).isPotentiallyValid);
};
export const useExpirationValidator = (value, message = "Expiry is invalid") => {
  const [isValid, setIsValid] = useState<boolean>();
  const [validationMessage, setValidationMessage] = useState<string>(message);
  useEffect(() => {
    const valid = validateExpiration(value);
    setIsValid(valid);
    if (valid === false) {
      setValidationMessage(message);
    }
  }, []);
  return { isValid, validationMessage, validateExpiration };
};
export const ExpirationInput: FC<MaskedInputProps & InputProps> = (props) => {
  const { overrides = {}, onChange, ...restProps } = props;
  const inputOverrides = getInputOverrides({
    size: restProps.size,
  });
  return (
    <MaskedInput
      onChange={onChange}
      endEnhancer={props.positive && PositiveEndEnhancer}
      overrides={mergeOverrides(inputOverrides, overrides)}
      {...restProps}
      placeholder="MM/YY"
      mask="99/99"
    />
  );
};
